<script lang="ts">
	export let totalW:number;
	export let totalH:number;
	export let camera:Camera;
	export let gridSizes:number[][];
	export let cubes:Cube[][];
	export let objects:Object3D[];
	export let textures:Texture[];
	export let groupObjects:Object3D[];
	export let selectedCallBack:Function;

    import { onMount } from 'svelte';
	import { init, drawGL, update } from "../scene";
    import type { Cube } from '../obj/Cube';
    import type { Camera, Object3D, Texture } from 'three';

    let canvas:HTMLCanvasElement;
	let frame:number;

	onMount(() => {

		init(canvas, gridSizes, totalW, totalH, camera, objects, textures, selectedCallBack);
		drawGL();

		(function loop() {
			frame = requestAnimationFrame(loop);
			update(cubes, groupObjects);
		}());

		return () => {
			cancelAnimationFrame(frame);
		};
	});

</script>

<style>
	div {
		background-color: #000000;
	}
	canvas {
		width: 100%;
		height: 100%;
		position: relative;
		left: 0;
		top: 0;
		background-color: #333;
        opacity: 0;
        transition: opacity 2s;
	}
</style>

<div>
	<canvas id="svelteCanvas" bind:this={canvas} />
</div>